import { render } from "./LandingHome.vue?vue&type=template&id=1849b01e"
import script from "./LandingHome.vue?vue&type=script&lang=js"
export * from "./LandingHome.vue?vue&type=script&lang=js"
script.render = render

export default script